import Api from "../apiService";

class savedFiltersApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/saved_filters`,
      params,
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/saved_filters`,
      data,
      Api.authHeaders()
    );
  }

  delete(companyId, id) {
    return Api.deleteRequest(
      `companies/${companyId}/saved_filters/${id}`,
      Api.authHeaders()
    );
  }
}

export default new savedFiltersApi();
